import { BaseAPI } from './BaseAPI.js'
import { Campaign } from '../types/index.js'

export default class CampaignsAPI extends BaseAPI<Campaign> {
  override get resource(): string {
    return '/campaigns'
  }
}
